module.exports = __webpack_public_path__ + "img/picture.9a91a90f.svg";